export default "__VITE_ASSET__e3ef22a6__"